import { render, staticRenderFns } from "./DropOffLocationDetails.vue?vue&type=template&id=99f73102&scoped=true"
import script from "./DropOffLocationDetails.vue?vue&type=script&lang=js"
export * from "./DropOffLocationDetails.vue?vue&type=script&lang=js"
import style0 from "./DropOffLocationDetails.vue?vue&type=style&index=0&id=99f73102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f73102",
  null
  
)

export default component.exports